import AppRoutes from "./routes";
// App component is the root component of the application
export default function App() {
  return <AppRoutes />;
}